module.exports = __webpack_public_path__ + "static/media/triple-park.424fde63.jpg";